import util from '../util'

let base = window.$servicePath
export default {

  listPlannedSubByBatchIdAndActivityId(batchId,activityId){
    return util.ajax(`${base}/api/process/listPlannedSubByBatchIdAndActivityId`,batchId,activityId)
  },

  //-----------------------流程设计
  listLatestDefinition(params){
    return util.ajax(`${base}/api/process/listLatestDefinition`, params.applicationId)
  },

  getLatestProcessData(params){
    return util.ajax(`${base}/api/process/getLatestProcessData`, params)
  },
  /**
   * 获取流程定义
   */
  getDefinition(params) {
    return util.ajax(`${base}/api/process/getData`, params)
  },
  /**
   * 获取流程定义
   */
  getFlowChartData(params) {
    return util.ajax(`${base}/api/process/getFlowChartData`, params)
  },

  /**
   * 创建流程定义
   */
  createDefinition(params) {
    return util.ajax(`${base}/api/process/create`, params)
  },
  copyDefinition(params){
    return util.ajax(`${base}/api/process/copy`, params)
  },
  removeDefinition(params) {
    return util.ajax(`${base}/api/process/remove`, params)
  },
  recoverDefinition(params){
    return util.ajax(`${base}/api/process/recover`, params)
  },
  /**
   * 更新流程定义
   */
  updateDefinition(params) {
    return util.ajax(`${base}/api/process/update`, params)
  },

  /**
   * 启用流程定义
   * @param params
   * @returns {*}
   */
  enableDefinition(params){
    return util.ajax(`${base}/api/process/enableDefinition`, params)
  },
  /**
   * 流程定义列表
   */
  listExclusiveMarkDeletedDefinition(appId, key) {
    return util.ajax(`${base}/api/process/listExclusiveMarkDeletedDefinition`, appId, key)
  },
  /**
   * 标记删除的流程定义列表
   * @param appId
   * @param key
   * @returns {*}
   */
  listMarkDeletedDefinition(appId, key){
    return util.ajax(`${base}/api/process/listMarkDeletedDefinition`, appId, key)
  },
  getLatestProcessDefinitionTree(params){
    return util.ajax(`${base}/api/process/getLatestProcessDefinitionTree`, params)
  },
  //--------------------------个人中心
  /**
   * 开始任务
   */
  listFlowStart(params) {
    return util.ajax(`${base}/api/process/listFlowStart`, params)
  },
  countFlowNum(params){
    return util.ajax(`${base}/api/process/countFlowNum`, params)
  },
  countFlowReadNum(params){
    return util.ajax(`${base}/api/process/countFlowReadNum`, params)
  },
  /**
  *统计AB角
  */
  countFlowAbDo(params){
    return util.ajax(`${base}/api/process/countFlowAbDo`, params)
  },
  /**
   * 待办工作列表
   */
  listFlowTodo(params) {
    return util.ajax(`${base}/api/process/listFlowTodo`, params)
  },
  /**
   * 已办工作列表
   */
  listFlowFinished(params) {
    return util.ajax(`${base}/api/process/listFlowFinished`, params)
  },
  /**
   * 部门发起工作列表
   */
  listDeptFlowFinished(params) {
    return util.ajax(`${base}/api/process/listDeptFlowFinished`, params)
  },
  /**
   * 流程草稿工作列表
   */
  listFlowDraft(params) {
    return util.ajax(`${base}/api/process/listFlowDraft`, params)
  },
  /**
   * 待阅工作列表
   */
  listFlowToRead(params) {
    return util.ajax(`${base}/api/process/listFlowToRead`, params)
  },

  /**
   * 已阅工作列表
   */
  listFlowFinishedRead(params) {
    return util.ajax(`${base}/api/process/listFlowFinishedRead`, params)
  },

  /**
   * 协同待办工作列表
   */
  listFlowDynamicTodo(params) {
    return util.ajax(`${base}/api/process/listFlowDynamicTodo`, params)
  },
  /**
   * 协同已办工作列表
   */
  listFlowDynamicFinished(params) {
    return util.ajax(`${base}/api/process/listFlowDynamicFinished`, params)
  },
  /**
   * 协同草稿工作列表
   */
  listFlowDynamicDraft(params) {
    return util.ajax(`${base}/api/process/listFlowDynamicDraft`, params)
  },

  /**
   * 运转工作列表
   */
  listFlowDoingWait(params) {
    return util.ajax(`${base}/api/process/listFlowDoingWait`, params)
  },

  /**
   * 委托正在办理工作列表
   * @param params
   * @returns {*}
   */
  listFlowDelegation(params) {
    return util.ajax(`${base}/api/process/listFlowDelegation`, params)
  },
  /**
   * 委托已办毕工作列表
   * @param params
   * @returns {*}
   */
  listFlowFinishedDelegation(params) {
    params.finished=true;
    return util.ajax(`${base}/api/process/listFlowDelegation`, params)
  },
  /**
   * 替办正在办理工作列表
   * @param params
   * @returns {*}
   */
  listFlowAgent(params) {
    return util.ajax(`${base}/api/process/listFlowAgent`, params)
  },
  /**
   * 替办已办毕工作列表
   * @param params
   * @returns {*}
   */
  listFlowFinishedAgent(params) {
    params.finished=true;
    return util.ajax(`${base}/api/process/listFlowAgent`, params)
  },

  /**
   * 意见要情 我发起的
   * @param params
   * @returns {*}
   */
  listFlowTrackDraft(params) {
    params.qType='draft';
    return util.ajax(`${base}/api/process/listFlowTrack`, params)
  },
  /**
   * 意见要情 我关注的
   * @param params
   * @returns {*}
   */
  listFlowTrackAttention(params) {
    params.qType='attention';
    return util.ajax(`${base}/api/process/listFlowTrack`, params)
  },
  /**
   * 回收站
   * @param params
   * @returns {*}
   */
  listFlowSuspend(params) {
    let key = params.key;
    // params.type=1;
    if('todo'==key){
      params.excludeStatus='MONITORED';
      params.excludeActivityType='dynamic';
      params.notFromMe = true;
    }else if('draft'==key){
      params.excludeStatus='MONITORED';
      params.excludeActivityType='dynamic';
      params.fromMe=true;
    }else if('dynamicdraft'==key){
      params.activityType='dynamic';
      params.fromMe=true;
    }else if('waitwork'==key){
      params.status='MONITORED';
    }
    return util.ajax(`${base}/api/process/listFlowSuspend`, params)
  },/**
   * 回收站统计数
   * @param params
   * @returns {*}
   */
  countFlowSuspend(params) {
    let key = params.key;
    //  params.type=1;
    if('todo'==key){
      params.excludeStatus='MONITORED';
      params.excludeActivityType='dynamic';
      params.notFromMe = true;
    }else if('draft'==key){
      params.excludeStatus='MONITORED';
      params.excludeActivityType='dynamic';
      params.fromMe=true;
    }else if('dynamicdraft'==key){
      params.activityType='dynamic';
      params.fromMe=true;
    }else if('waitwork'==key){
      params.status='MONITORED';
    }
    return util.ajax(`${base}/api/process/countFlowSuspend`, params)
  },


  listWaitDeleteDoc(params) {
    return util.ajax(`${base}/api/process/listWaitDeleteDoc`, params)
  },
  /**
   * AB角待办工作列表
   */
  listFlowAbDo(params) {
    return util.ajax(`${base}/api/process/listFlowAbDo`, params)
  },
  //--------------------视图按钮操作--------------
  claim(taskId,params){
    if(!params) params = {};
    params.taskId = taskId;
    return util.ajax(`${base}/api/process/claimByParams`, params)
  },
  updateAccessTime(params){
    if(!params.batchId) return;
    return util.ajax(`${base}/api/process/updateAccessTime`, params)
  },
  getFlowProcess(params){
    return util.ajax(`${base}/api/process/getFlowProcess`, params.batchId,params)
  },
  getFlowOperationRecord(params){
    return util.ajax(`${base}/api/process/getFlowOperationRecord`, params.batchId,params)
  },
  batchCommit(params) {
    return util.ajax(`${base}/api/process/batchCommit`,params)
  },
  reject(params) {
    return util.ajax(`${base}/api/process/reject`,params)
  },
  save(params) {
    return util.ajax(`${base}/api/process/save`,params)
  },
  /**
   * 批量阅毕
   */
  batchCommitCircular(taskIds){
    return util.ajax(`${base}/api/process/batchCommitCircular`, taskIds)
  },
  /**
   * 批量转办
   * @param taskIds
   * @param params
   *            {receiver:{id:接收人唯一ID, name:接收人名, type:身份类型}}
   * @returns {*}
   */
  batchTransfer(taskIds, params){
    return util.ajax(`${base}/api/process/batchTransfer`, taskIds, params)
  },
  transfer(taskId, params){
    return util.ajax(`${base}/api/process/transfer`, taskId, params)
  },
  /**
   * 批量抢办
   * @param taskIds
   * @returns {*}
   */
  batchAbGrab(taskIds){
    return util.ajax(`${base}/api/process/batchAbGrab`, taskIds)
  },
  /**
   * 取消委托，交还委托人
   * @param taskId
   * @param params
   *          checkGoOut  是否检查外出设置 true/false
   * @returns {*}
   */
  resolve(taskId, params){
    return util.ajax(`${base}/api/process/resolve`, taskId, params)
  },
  /**
   * 检查是否可取回
   * @param taskId
   * @param params
   *            containClaimed 存在已签收的是否也可取回 true/false
   * @returns {*}
   */
  checkCanTaken(taskId, params){
    return util.ajax(`${base}/api/process/checkCanTaken`, taskId, params)
  },
  /**
   * 取回
   * @param taskId
   * @returns {*}
   */
  taken(taskId,params){
    return util.ajax(`${base}/api/process/takenParams`, taskId,params)
  },
  /**
   * 删除传阅任务
   * @param taskId
   * @returns {*}
   */
  deleteCircularTask(params){
    return util.ajax(`${base}/api/process/deleteCircularTask`, params)
  },
  /**
   * 检查是否可催办
   * @param taskId
   * @returns {*}
   */
  checkCanUrge(taskId){
    return util.ajax(`${base}/api/process/checkCanUrge`, taskId)
  },

  /**
   * 检查是否可催办
   * @param taskId
   * @param 批次Id
   * @returns {*}
   */
  checkAllCanUrge(batchId,taskId){
    return util.ajax(`${base}/api/process/checkAllCanUrge`, batchId,taskId)
  },
  /**
   * 挂起
   */
  batchSuspend(taskIds){
    return util.ajax(`${base}/api/process/batchSuspend`, taskIds)
  },
  /**
   * 挂起释放文号
   */
  batchSuspendReleaseWH(params){
    return util.ajax(`${base}/api/process/batchSuspendReleaseWH`, params)
  },
  /**
   * 激活
   * @param businesses [{businessId:文档ID, batchId:批次ID, draftsDocId:起草文档ID,formEntityKey:表单实体ID,moduleId:模块ID}]
   */
  batchActivate(businesses){
    return util.ajax(`${base}/api/process/batchActivate`, businesses)
  },
  batchActivateDocs(businesses){
    return util.ajax(`${base}/api/process/batchActivateDocs`, businesses)
  },
  /**
   * 批量标记删除
   * @param businesses  [{businessId:文档ID, batchId:批次ID, draftsDocId:起草文档ID,formEntityKey:表单实体ID,moduleId:模块ID}]
   * @returns {*}
   */
  batchMarkDelete(businesses){
    return util.ajax(`${base}/api/process/batchMarkDelete`, businesses)
  },

  /**
   * 保存虚拟日志、意见代录
   * @param params
   * @returns {*}
   */
  saveVirtualRecord(params){
    return util.ajax(`${base}/api/process/saveVirtualRecord`, params)
  },
  /**
   * 获取领导绑定数据
   * @param taskId
   * @returns {*}
   */
  getBindLeaderData(taskId){
    return util.ajax(`${base}/api/process/getBindLeaderData`, taskId)
  },
  delegateSecretaryRecord(params){
    return util.ajax(`${base}/api/process/delegateSecretaryRecord`, params)
  },
  delegateSendSecretary(params){
    return util.ajax(`${base}/api/process/delegateSendSecretary`, params)
  },
  delegateSendLeader(params){
    return util.ajax(`${base}/api/process/delegateSendLeader`, params)
  },
  thoroughDeleteDoc(params){
    return util.ajax(`${base}/api/process/thoroughDeleteDoc`, params)
  },
  //--------------------视图按钮操作 end--------------
  /**
   *
   */
  getFlows(taskId, params) {
    return util.ajax(`${base}/api/process/getFlows`, taskId, params)
  },
  /**
   */
  getFlowGroups(taskId,flowId,params) {
    return util.ajax(`${base}/api/process/getFlowGroups`, taskId,flowId, params)
  },

  /**
   */
  getFlowGroupUserOrPositions(taskId,flowId,groupId,params) {
    return util.ajax(`${base}/api/process/getFlowGroupUserOrPositions`, taskId,flowId,groupId,params)
  },

  getCanRejectTo(params) {
    return util.ajax(`${base}/api/process/getCanRejectTo`, params.taskId)
  },

  /*获取任务记录*/
  getTaskEntityData(taskId) {
    return util.ajax(`${base}/api/process/getTaskEntityData`, taskId)
  },

  listModuleLatestProcDefTree(params){
    return util.ajax(`${base}/api/process/listModuleLatestProcDefTree`, params)
  },
  getActivityFlows(params){
    return util.ajax(`${base}/api/process/getActivityFlows`, params)
  },
  /**
   * 获取运转流向数据
   * @param params
   * @returns {*}
   */
  getWorkFlows(params){
    return util.ajax(`${base}/api/process/getWorkFlows`, params)
  },
  /**
   * 获取运转流向列表结构数据
   * @param params
   * @returns {*}
   */
  getWorkFlowLists(params){
    return util.ajax(`${base}/api/process/getWorkFlowLists`, params)
  },
  /**
   * 获取运转流向树结构数据
   * @param params
   * @returns {*}
   */
  getWorkFlowTrees(params){
    return util.ajax(`${base}/api/process/getWorkFlowTrees`, params)
  },
  /**
   * 保存拟办数据
   * @param params
   * @returns {*}
   */
  planned(params){
    return util.ajax(`${base}/api/process/planned`, params)
  },
  /**
   * 运转取回
   * @param params
   * @returns {*}
   */
  batchTakenSubProcess(params){
    return util.ajax(`${base}/api/process/batchTakenSubProcess`, params)
  },
  /**
   * 获取拟办流向数据
   * @param params
   */
  getPlannedFlows(params){
    return util.ajax(`${base}/api/process/getPlannedFlows`, params)
  },
  getNextActivityCandidates(params){
    return util.ajax(`${base}/api/process/getNextActivityCandidates`, params)
  },
  refreshProcessCache(){
    return util.ajax(`${base}/api/process/refreshProcessCache`)
  }
}



// WEBPACK FOOTER //
// ./src/common/api/process.js